import { createSelector } from 'reselect';

const selectGlobaleEvents = (state: any) => state.globalEvents;


export const selectGlobaleEventsCurrentItem = createSelector([selectGlobaleEvents], (globalEvents) => globalEvents.current);

export const selectGlobaleEventsListItems = createSelector([selectGlobaleEvents], (globalEvents) => globalEvents.list);

export const selectGlobaleEventsItemById = (itemId: any) =>
    createSelector(selectGlobaleEventsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectGlobaleEventsQueryItems = createSelector([selectGlobaleEvents], (globalEvents) => globalEvents.query);

export const selectGlobaleEventsCreatedItem = createSelector([selectGlobaleEvents], (globalEvents) => globalEvents.create);

export const selectGlobaleEventsUpdatedItem = createSelector([selectGlobaleEvents], (globalEvents) => globalEvents.update);

export const selectGlobaleEventsReadItem = createSelector([selectGlobaleEvents], (globalEvents) => globalEvents.read);

export const selectGlobaleEventsDeletedItem = createSelector([selectGlobaleEvents], (globalEvents) => globalEvents.delete);

export const selectGlobaleEventsSearchedItems = createSelector([selectGlobaleEvents], (globalEvents) => globalEvents.search);

export const selectGlobaleEventsItemsCount = createSelector([selectGlobaleEvents], (globalEvents) => globalEvents.count);

export const selectGlobaleEventsItemsFilter = createSelector([selectGlobaleEvents], (globalEvents) => globalEvents.filter);

export const selectGlobaleEventsSummaryItems = createSelector([selectGlobaleEvents], (globalEvents) => globalEvents.summary);